export default __webpack_public_path__ + "static/media/logo.4cbbb3c8.svg";